import { groupCubeRows, usd, type ExecutiveTransaction } from "../../data/executiveOverview";
import "../../spendiq.css";

const regionColors = ["#492750", "#3265AA", "#61BA93", "#E9702F"];

export function SpendByGeographyPanel({ rows }: { rows: ExecutiveTransaction[] }) {
  const regions = groupCubeRows(rows, "Geography");
  const largest = regions[0]?.amount || 1;

  return (
    <div className="spendbygeography-panel">
      <div className="spendbygeography-panel__title">SPEND BY GEOGRAPHY</div>
      <div className="spendbygeography-panel__canvas">
        <div style={{ width: "100%", padding: "24px 32px", display: "flex", flexDirection: "column", justifyContent: "center", gap: 24 }}>
          {regions.map((region, index) => (
            <div key={region.label} style={{ display: "grid", gridTemplateColumns: "110px 1fr 72px", gap: 12, alignItems: "center", fontSize: 12 }}>
              <span>{region.label}</span>
              <div style={{ background: "#E5E7EB", height: 22, borderRadius: 4, overflow: "hidden" }}>
                <div style={{ width: `${region.amount / largest * 100}%`, height: "100%", background: regionColors[index % regionColors.length] }} />
              </div>
              <strong style={{ textAlign: "right" }}>{usd(region.amount)}</strong>
            </div>
          ))}
          {!regions.length && <span>No spend matches the selected filters.</span>}
        </div>
      </div>
    </div>
  );
}